import {takeLatest,all,call,put} from 'redux-saga/effects';
import { setMessagesFailStart, setMessagesStart, setMessageStart } from './chat.action';
import { handleAddMessage, handleGetMessages } from './chat.helper';
import { chatTypes } from './chat.types';


export function* addMessage({payload}) {
    try {
       const message = yield handleAddMessage(payload);
       yield put(setMessageStart(message));
    } catch (err) {
        console.log(err);
    }
}

export function* getMessages({payload}){
    try {
       const Messages = yield handleGetMessages(payload);
       if(Messages.length > 0) {
        yield put(setMessagesStart(Messages));
       }else {
        yield put(setMessagesFailStart());
       }
    }catch(err) {
        console.log(err);
    }
}

export function* onAddMessageStart() {
    yield takeLatest(chatTypes.ADD_CHAT_MESSAGE,addMessage);
}

export function* onGetMessagesStart() {
    yield takeLatest(chatTypes.GET_MESSAGES,getMessages);
}
export function* chatSaga() {
    yield all([
        call(onAddMessageStart),
        call(onGetMessagesStart)
    ]);
}